import React, { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { BaseUrl } from "../../../../redux/config";
import axios from "axios";
import { getSession } from "../../../../redux/actions/authActions";
import "./Patient.scss";
import commObj from "../../../../constants/Common";
import PaymentSuccessModal from "../../../../Modals/PaymentSuccessModal";
import PaymentFailedModal from "../../../../Modals/PaymentFailedModal";
import { CustomCard } from "../../../CustomCard";
import TextAreaModal from "../../../../Modals/TextAreaModal";
import { toast } from "react-toastify";

export const PatientCard = ({
  data,
  currentData,
  bookingData,
  handleSubmitPay,
}) => {
  const { user_profile_id, role_id } = getSession();
  const [url, setUrl] = useState(null);
  const [inputValue, setInputValue] = useState("");
  const [loading, setIsLoading] = useState(false);
  const [showTextArea, setShowTextArea] = useState(false);

  const {
    svcuser_profile_id,
    user_first_name,
    user_phone_nbr,
    user_last_name,
    user_iso_cntry_cde,
    user_iso_city_name,
    addr_street1,
  } = data;
  const { svc_id, svc_name, svc_cost_amt, svc_svcf_id } = currentData;
  const { ord_svc_date, ord_svc_time } = bookingData || {};

  const postData = {
    ord_svc_date,
    ord_svc_time,
    order_dte_tsp: "2022-07-15T12:00:00Z",
    order_tot_amt: svc_cost_amt,
    order_tot_tax: 0.0,
    order_tot_fees: 0.0,
    order_svcf_id: svc_svcf_id,
    user_profile_id,
    order_svc_user_id: svcuser_profile_id,
    order_ship_to_id: 2,
    order_ship_instructions: inputValue || "",
    order_bill_to_id: 2,
    order_status_id: 1,
    sys_user_id: user_profile_id,
    role_id,
    sys_source_ip: "192.168.2.2",
    sys_crte_tsp: "2022-07-15T12:00:00Z",
    sys_last_updte_tsp: "2022-07-15T12:30:00Z",
    sys_ord_active_yn: "Y",
    service_order_line: [
      {
        svc_id,
        svc_name,
        svc_qnty_nbr: 1,
        svc_status_id: 1,
        svc_price_amt: svc_cost_amt,
        svcfee_id: 1,
        sys_user_id: user_profile_id,
        sys_ordl_active_yn: "Y",
        sys_crte_tsp: "2022-07-15T12:00:00Z",
        sys_last_updte_tsp: "2022-07-15T12:30:00Z",
      },
    ],
  };

  useEffect(() => {
    if (url) {
      window.location.href = url;
    }
  }, [url]);

  const handleSubmit = async () => {
    const { token } = getSession();
    setIsLoading(true);

    try {
      let response = await axios.post(`${BaseUrl}pay/ps`, postData, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      setUrl(response.data.session_url);
      return response.data;
    } catch (err) {
      toast.error(
        `${
          err.response?.data?.usr?.message ||
          err.response?.data?.message ||
          err.response?.message ||
          err.message
        }`
      );
    } finally {
      setIsLoading(false);
    }
  };

  const user_phone_nbrf = commObj.formatPhoneNumber(user_phone_nbr, "ZW");

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  const [modalShow, setModalShow] = useState(false);
  const [failedModalShow, setFailedModalShow] = useState(false);

  return (
    <div>
      <CustomCard className="facility patient-card">
        <div
          className="d-flex justify-content-between align-items-center !pb-3 !mb-4"
          style={{ borderBottom: "1px solid #E7E7E9" }}
        >
          <div className="d-flex align-items-center justify-content-center gap-2">
            <div>
              <h6 className="card-title mb-0">{`${user_first_name} ${user_last_name}`}</h6>
              <small>#{svcuser_profile_id}</small>
            </div>
          </div>
        </div>

        <div className="row gap-y-[18px]">
          <div className="col-6">
            <small>Mobile No:</small>
            <p className="truncate mb-0">{user_phone_nbrf}</p>
          </div>
          <div className="col-6">
            <small>Address:</small>
            <p className="truncate mb-0">{addr_street1}</p>
          </div>
          <div className="col-6">
            <small>City Name:</small>
            <p className="truncate mb-0">{user_iso_city_name}</p>
          </div>
          <div className="col-6">
            <small>Country:</small>
            <p className="truncate mb-0">{user_iso_cntry_cde}</p>
          </div>
        </div>

        <div className="flex justify-end relative mt-4">
          <div className="flex gap-3 w-full justify-between">
            <button
              className="sign_btn !w-full !text-xs"
              style={{ boxSizing: "border-box" }}
              onClick={handleSubmitPay}
            >
              <p className="!m-0 text-white !p-0">Checkout</p>
            </button>

            {role_id === 1 && (
              <button
                className="sign_btn !w-full !text-xs"
                onClick={handleSubmit}
              >
                {loading ? (
                  <Spinner animation="border" variant="white" />
                ) : (
                  <b>Donor Order</b>
                )}
              </button>
            )}
          </div>
        </div>
      </CustomCard>
      <TextAreaModal
        show={showTextArea}
        onHide={() => setShowTextArea(false)}
        value={inputValue}
        handleInputChange={handleInputChange}
        handleSubmit={handleSubmit}
        loading={loading}
      />
      <PaymentSuccessModal
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
      <PaymentFailedModal
        show={failedModalShow}
        onHide={() => setFailedModalShow(false)}
      />
    </div>
  );
};
